/*  ==============================================
//  Created by nguyendx                          ||
//  create at: 2017-10-25                        ||
//===============================================*/
import { Component, EventEmitter, Injectable, Injector, OnInit, Output } from '@angular/core';
import { FormBuilder, NgForm } from '@angular/forms';
import { UploadService } from '../../../../common/services/Upload.service';
import { ConfirmationService } from 'primeng/primeng';
import { EvsStoreService } from '../../../../common/services/EvsStore.service';
import { Location } from '@angular/common';
import { CategoryService } from '../../../../common/services/Category.service';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;
var that;
@Component({
    moduleId: module.id,
    selector: 'store_add',
    templateUrl: './store_add.component.html',
    styleUrls: ['./store.css'],
    providers: [ConfirmationService, EvsStoreService, EvsAddressService]
})
@Injectable()
export class StoreAddComponent implements OnInit {
    @Output('backComponent') backComponent = new EventEmitter();
    public store: any = {};
    public message: { class: string, content: string } = null;
    public error: string = '';
    public cities: Array<any> = [];
    public districts: Array<any> = [];

    // listType = [
    //     { id: 1, value: 1, label: 'Điểm bán' },
    //     { id: 2, value: 2, label: 'Bảo hành' },
    //     { id: 3, value: 3, label: 'Điểm bán + Bảo hành' }
    // ];

    constructor(private injector: Injector,
        private _location: Location,
        private storeService: EvsStoreService,
        public addressService: EvsAddressService,
        private upload: UploadService,
        private cate: CategoryService,
        private _fb: FormBuilder,
        private toastr: ToastrService,
        public translate: TranslateService) {
        that = this;
    }

    ngOnInit() {
        this.getCity();
        const provinces = $('#provinces');
        const districts = $('#districts');

        this.translate.get(['CHON_TINHTP', 'CHON_QUANHUYEN']).subscribe(res => {
            provinces.select2({ placeholder: res['CHON_TINHTP'], allowClear: false, width: '100%' });
            districts.select2({ placeholder: res['CHON_QUANHUYEN'], allowClear: false, width: '100%' });
        });

        this.translate.onLangChange.subscribe(() => {
            this.translate.get(['CHON_TINHTP', 'CHON_QUANHUYEN']).subscribe(res => {
                provinces.select2({ placeholder: res['CHON_TINHTP'], allowClear: false, width: '100%' });
                districts.select2({ placeholder: res['CHON_QUANHUYEN'], allowClear: false, width: '100%' });
            });
        });

        provinces.on('select2:select', (e: any) => {
            setTimeout(() => {
                $('.select2-selection__rendered').removeAttr('title');
                const id = e.target.value;
                this.loadDistrictData(id);
            }, 100);
        });

        districts.on('select2:select', () => {
            $('.select2-selection__rendered').removeAttr('title');
        });

        this.store.status = 1;
    }

    getCity() {
        this.addressService.getCities().subscribe(res => {
            let citiesList = [];
            res.data.cities.forEach((c: any) => {
                citiesList.push({
                    value: c.name,
                    label: c.name,
                    id: c.id,
                });
            });
            this.cities = citiesList;
        });
    }

    loadDistrictData(id: number) {
        this.addressService.getDistrict({ city_id: id }).toPromise().then(res => {
            let districts = [];
            res.data.districts.forEach((c: any) => {
                districts.push({
                    value: c.name,
                    label: c.name,
                    id: c.id,
                });
            });
            this.districts = districts;
        })
    }

    onSubmit(form: NgForm) {
        this.message = null;
        let objectData = {};

        // let type = $('#types').val();
        let province = $('#provinces option:selected').val();
        let district = $('#districts option:selected').val();


        if (this.store.name.trim().length === 0)
            this.message = { class: "alert alert-danger", content: this.translate.instant('TEN_KHONG_DUOC_BO_TRONG') };
        // else if (!type)
        //     this.message = { class: "alert alert-danger", content: "Bạn chưa chọn loại điểm bán, bảo hành !" };
        else if (!province)
            this.message = { class: "alert alert-danger", content: this.translate.instant('BAN_CHUA_CHON_TINHTP') };
        else if (!district)
            this.message = { class: "alert alert-danger", content: this.translate.instant('BAN_CHUA_CHON_QUANHUYEN') };
        else if (this.store.address.trim().length === 0)
            this.message = { class: "alert alert-danger", content: this.translate.instant('DIA_CHI_KHONG_DUOC_BO_TRONG') };
        else {
            this.processSave();
            this.store.province = $('#provinces option:selected').text();
            this.store.district = $('#districts option:selected').text();
            objectData = {
                "name": this.store.name,
                "type": 2,
                "status": this.store.status,
                "province": province,
                "district": district,
                "address": this.store.address,
                "code": this.store.code
            };
            this.storeService.createNew(objectData).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        // this.message = {
                        //     class: "alert dark alert-danger",
                        //     content: res.status + ' : ' + res.message
                        // };
                        this.toastr.error(this.translate.instant('THO_TAC_THEM_MOI_THAT_BAI'), '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        // this.message = {
                        //     class: "alert dark alert-success",
                        //     content: "Thêm mới thành công"
                        // };
                        this.resetForm(form);
                        this.toastr.success(this.translate.instant('THO_TAC_THEM_MOI_THANH_CONG'), '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.backComponent.emit({
                            isBack: false
                        });
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        }
        this.scrollToTop();
    }

    resetForm(frm: NgForm) {
        frm.resetForm();
        // $('#name').val('');
        // $('#code').val('');
        $('#address').val('');
        // $('#type').val('').trigger('change');
        $('#provinces').val('').trigger('change');
        $('#districts').val('').trigger('change');
        this.store.status = 1;
        this.store.name = '';
        this.store.code = '';
    }

    backToComponent() {
        this.backComponent.emit({
            isBack: true
        });

        //this._location.back();
    }

    processSave() {
        this.message = {
            class: "alert dark alert-info",
            content: this.translate.instant('DANG_THUC_THI')
        };
    }

    scrollToTop() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
    }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/store_manager/store_add.component.ts